import * as API_CONSTANT from '../constants'

export const cuDriver = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/cu`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

export const createDriverSchedule = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/schedule/create`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

export const createDrivers = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/bulk/create`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

export const getDriverGroupByDRVGID = (drvgid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/getGroup`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            drvgid
        })
    })
    .then(res => res.json())
)

export const getDriverGroupBatch = (drvgid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/batch/getGroup`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            drvgid
        })
    })
    .then(res => res.json())
)

export const getDriverInfoBatch = (drvids) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/batch/getInfo`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            drvids
        })
    })
    .then(res => res.json())
)

export const getDriverSession = (drvid) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/session/latest/get`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            drvid
        })
    })
    .then(res => res.json())
)

export const getIncidentReport = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/report/incident/get/timeframe/sync`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const createIncidentReport = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/incident/create`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const updateIncidentReport = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/incident/update`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const createDriverPretip = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/pretrip/create`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)

export const getDriverPretipByDRVID = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/pretrip/timeframe/drvid`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(items)
    })
    .then(res => res.json())
)


export const getAllDriverChecklistItem = () => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/checklistitem/get/all`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({})
    })
    .then(res => res.json())
)

export const getDriverByICNumber = (icNumber) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/get/icNumber`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify({
            icNumber: icNumber
        })
    })
    .then(res => res.json())
)

export const getDriverPerformanceDashboard = (items) => (
    fetch(`${API_CONSTANT.fms_v3_fe_path}/driver/performance/dashboard`, {
        method: 'POST',
        headers: API_CONSTANT.headers,
        body: JSON.stringify(
            items
        )
    })
    .then(res => res.json())
)

